<template>
  <div class="">
    <headerBar :activeIndex="activeIndex"></headerBar>
    <banner :carousel="info.carousel" :Mcarousel="info.Mcarousel"></banner>
    <div class="characteristic">
      <div
        class="pc main-content1"
        style="padding-top: 100px; padding-bottom: 100px"
      >
        <div style="width: 100%; margin: 0 auto">
          <img src="../../assets/wuyan.png" alt="" style="width: 100%" />
        </div>
        <div class="flex-center" style="margin: 20px 0">
          <template v-for="(item, index) of titleList">
          <div
            style="flex: 1; text-align: center"
            v-if="item.isContent === 1"
            :key="index"
          >
            <div
              :class="
                'select-bar ' +
                (type.name === item.main_title ? 'select-bg' : '')
              "
              @click="getPdf(item)"
            >
              {{ item.main_title }}
            </div>
          </div>
          </template>
        </div>
        <div
          style="min-height: 600px; width: 100%; background: #fff"
          v-if="pdfPath !== ''"
        >
          <div v-html="pdfPath"></div>
        </div>
      </div>
      <div class="mobile main-content1" style="">
        <div class="big-title" style="margin-bottom: 30px">
          <div class="big-name">特色医疗</div>
          <div class="big-eng">
            <span class="line-left"></span>
            <span class="txt">characteristic</span>
            <span class="line-right"></span>
          </div>
        </div>
        <div class="" style="margin: 0.2rem 0.13rem; position: relative">
          <div
            style="float: left; width: 0.15rem; margin-top: 0.06rem"
            @click="last"
          >
            <img
              src="../../assets/mobile/left.png"
              alt=""
              style="width: 100%"
            />
          </div>
          <van-tabs
            style="width: calc(100% - 0.3rem); float: left"
            v-model="active"
            type="card"
            swipeable
            color="#f3f3f3"
            background="#f3f3f3"
            :swipe-threshold="3"
            @click="switchTab"
          >
            <template
                v-for="(item, index) of titleList">
              <van-tab
                :key="index"
                v-if="item.isContent === 1"
                :title="item.main_title"
                :title-class="`${index === active ? 'select-bg' : 'select-bar'}`"
              >
              </van-tab>
            </template>
          </van-tabs>

          <div
            style="float: left; width: 0.15rem; margin-top: 0.06rem"
            @click="next"
          >
            <img
              src="../../assets/mobile/right.png"
              alt=""
              style="width: 100%"
            />
          </div>
          <div class="clear"></div>
        </div>
        <div
          style="
            min-height: 3rem;
            width: 100%;
            background: #fff;
            border-top: 5px solid #f3f3f3;
            padding-top: 5px;
          "
          v-loading="loading"
        >
          <div v-html="pdfPath"></div>
        </div>
      </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
import { getmenudetail, medicallist, medicalDetail } from "@/api/common";
export default {
  name: "HelloWorld",
  components: { banner, footerBar, headerBar },
  data() {
    return {
      type: {
        name: "",
        id: null,
      },
      active: 0,
      activeIndex: "characteristic",
      info: { carousel: "", Mcarousel: "" },
      titleList: [],
      pdfPath: "",
      loading: true,
    };
  },
  mounted() {
    getmenudetail({ id: 6 }).then((res) => {
      if (res.data.banner_pc_images && res.data.banner_pc_images !== "") {
        res.data.carousel = res.data.banner_pc_images.split(",");
        res.data.Mcarousel = res.data.banner_mobile_images.split(",");
      }
      this.info = res.data;
    });

    medicallist().then((res) => {
      var titleList = []
      res.data.forEach(item => {
        if(item.isContent === 1){
          titleList.push(item)
        }
      });
      this.titleList = titleList;
      if (this.$route.query.type) {
        this.active = this.$route.query.active;
        this.getPdf(this.titleList[this.active]);
        this.fx(this.titleList[this.active],1)
      } else {
        this.getPdf(res.data[0]);
        this.fx(this.titleList[this.active],0)
      }
    });
  },
  methods: {
    fx(row,type){
      var name = "东莞黄家圣幸中医医院"
      var title = row.main_title
      var icon = row.images_icon
      var url = "http://www.sensin.com.cn/characteristic"
      if(type === 1){
        url + `?type=${this.type.id}&active=${this.active}`
      }
      this.postMessage(
          name,
          title,
          url,
          icon
        );
    },
    getPdf(item) {
      this.loading = true;
      this.pdfPath = "";
      this.type.name = item.main_title;
      this.type.id = item.id;
      medicalDetail({ id: item.id }).then((res) => {
        this.loading = false;
        this.pdfPath = res.data.ppt;
      });
    },
    switchTab(name, title) {
      this.getPdf(this.titleList[name]);
      this.fx(this.titleList[name],1)
    },
    last() {
      if (this.active !== 0) {
        this.active--;
        this.getPdf(this.titleList[this.active]);
        this.fx(this.titleList[this.active],1)
      }
    },
    next() {
      if (this.active !== this.titleList.length - 1) {
        this.active++;
        this.getPdf(this.titleList[this.active]);
        this.fx(this.titleList[this.active],1)
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.characteristic .pc .select-bg {
  background-image: url(../../assets/textBg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 80px;
  line-height: 80px;
  color: #e5e5e5;
}
.characteristic .pc .select-bar {
  width: 190px;
  margin: 0 auto;
  padding: 0 70px 0 0;
  font-size: 17px;
  cursor: pointer;
}
.characteristic .pc .img-border {
  background-image: url(../../assets/border.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #e5e5e5;
  width: 100%;
}
.img-text {
  margin-top: 8px;
  color: #ad4b1c;
  font-size: 16px;
}
@media screen and (max-width: 750px) {
  .characteristic .mobile {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/characteristic/index.vue